<template>
    <div class="flex-grid flex-grid--reduced-bottom-margin a-form-inputs">
        <div class="flex-grid__item">
            <div class="flex-grid">
                <div class="flex-grid__g-7">
                <claim-status></claim-status>
            </div>
                <modal-in-the-wild modal-name="search_individual_claim">
                    <button class="a-button a-button--small u-no-margin">
                        Load Claim
                    </button>
                </modal-in-the-wild>
            </div>
            <individual-search-modal></individual-search-modal>
        </div>
    </div>
</template>

<script>
    import ClaimStatus from 'pages/discount-rate-comparison/components/form/ClaimStatus.vue';
    import IndividualSearchModal from 'pages/discount-rate-comparison/components/modal/IndividualSearchModal.vue';
    import Control from 'components/form/Control.vue';
    import ModalInTheWild from 'components/modal/ModalInTheWild.vue';
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

    export default {
        name: 'individual-search',
        components: {
            ClaimStatus,
            Control,
            IndividualSearchModal,
            ModalInTheWild,
        },
        computed: {
            ...mapState('discountRateComparison', {

            }),
        },
        methods: {
            ...mapActions('discountRateComparison', [
                
            ]),
        }
    }
</script>



// WEBPACK FOOTER //
// IndividualSearch.vue?59aa7380